import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
	color: ${(props) => props.theme.v3.colors.blue[6]};
	text-decoration: none;
	font-size: 0.875rem;
	&:hover {
		text-decoration: underline;
	}
`;
